module.exports = function () {
    $('body').on('click', '.js-login-mobile', (event) => {
        let $modalContainer = $($('.js-mobile-modal').html());
        $('body').append($modalContainer);
        window.dialogManager.openDialog('panel', '#accountModal', event.target);
    });
};
